<template>
  <el-table class="detail-table" :data="list" fit :header-cell-style="headerCellStyle" :cell-style="cellStyle">
    <el-table-column label="项目名称" min-width="180">
      <template slot-scope="scope">
        <span class="text-cut" :title="scope.row.gonggaoTitle">{{ scope.row.gonggaoTitle }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="statusName" label="状态" width="180" align="center" />
    <el-table-column label="操作" width="120">
      <template slot-scope="{row}">
        <el-button type="primary" plain size="small" class="select-btn" @click="viewDetail(row)">选中查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    headerCellStyle() {
      const str = "background-color: #f9f9f9;padding: 8px 0;text-align: center;"
      return str
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = "padding: 10px 0;"
      if (columnIndex === 2) {
        str += "display: flex;justify-content: center;"
      }
      return str
    },
    // 查看详情
    viewDetail(row) {
      const href = this.$router.resolve({ path: "/purchase/detail/xmxx", query: Object.assign(this.$route.query, { sectionId: row.id }) }).href
      window.open(href, "__blank")
    }
  }
};
</script>

<style scoped lang="scss">
  .detail-table{
    margin-top: 20px;
    border: 1px solid #ddd;
    border-bottom: 0;
    &::before{
      height: 0;
    }
    .select-btn{
      width: 70px;
      height: 24px;
      padding: 0;
      text-align: center;
      border-radius: 0;
    }
  }
  .detail-content{
    background-color: #fff;
    padding: 0 20px;
    border: 1px solid #ddd;
    margin-top: 20px;
    .detail-content-header{
      height: 136px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
</style>
